exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".emptyStateContainer{margin-bottom:25px}.emptyStateContainer .rightContent{padding-left:5%;border-left:1px solid #ddd;min-height:600px}.emptyStateContainer .rightContent,.emptyStateContainer .sideBar{padding-top:20px}.emptyStateContainer .emptyStateContent .emptyImg{max-width:45%}.emptyStateContainer .emptyRightContent .emptyImg{max-width:85%}.emptyStateContainer .emptyRightContent .insightsEmptyText{margin-bottom:35px;display:inline-block;width:60%}.emptyStateContainer .emptyRightContent .buttonPrimary{margin-left:60px}.emptyStateContainer .sideBar .emptyStudentRowContainer img{vertical-align:top}.emptyStateContainer .sideBar .emptyStudentRowContainer .emptyStudentRow{display:inline-block;height:13px;margin-bottom:15px;background:#eee;border-radius:2px;margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/empty_state_container.scss
// module id = 1470
// module chunks = 0